export enum CharmSelectionType {
    /**
     * No charm set
     */
    None,

    /**
     * Charm set by automatic keyword
     */
    Automatic,

    /**
     * Charm set by suggestion
     */
    Suggestion,

    /**
     * Charm set manually via picker
     */
    Manual,
}

/**
 * Type of compose forms possible
 */
export type ComposeFormType = 'QuickCompose' | 'FullCompose';
export const QUICK_COMPOSE_FORM_TYPE: ComposeFormType = 'QuickCompose';
export const FULL_COMPOSE_FORM_TYPE: ComposeFormType = 'FullCompose';

/**
 * Type of full compose form views possible
 *
 * Note: This is used for instrumentation so existing values need to be kept
 *       the same, hence DeeplinkPopOut keeping 'PopOut' and not 'DeeplinkPopOut'
 */
export enum FullComposeFormViewType {
    Modal = 'Modal',
    DeeplinkPopOut = 'PopOut',
    ProjectionPopOut = 'ProjectionPopOut',
}

/**
 * Type of quick compose form views possible
 */
export type QuickComposeViewType = 'Surface' | 'TimePanel' | 'BoardCalendarAsset';
export const QUICK_COMPOSE_VIEW_TYPE_SURFACE = 'Surface';
export const QUICK_COMPOSE_VIEW_TYPE_TIME_PANEL = 'TimePanel';
